// extracted by mini-css-extract-plugin
export var cancelButton = "_nh-5";
export var content = "_nh-3";
export var createButton = "_nh-6";
export var drawerContainer = "_nh-0";
export var footer = "_nh-2";
export var header = "_nh-1";
export var orderFormColumn = "_nh-4";